export default __webpack_public_path__ + "static/media/suv_light.8d566ad3.png";